// Testi dello stato SLA di un ticket (elenco e dettaglio): quanto manca alla scadenza, o di quanto è in ritardo.
// Lo stato (late | soon | ok | paused) lo calcola il server (TicketSla::state): qui si mostra soltanto.
import { parseDbDate } from './kernelFormat';

export function fmtDuration(ms, t) {
  const minutes = Math.max(1, Math.round(Math.abs(ms) / 60000));
  if (minutes < 60) return t('tickets.durMin', { n: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 48) {
    const rest = minutes % 60;
    return rest && hours < 6 ? t('tickets.durHourMin', { h: hours, m: rest }) : t('tickets.durHour', { n: hours });
  }
  return t('tickets.durDay', { n: Math.floor(hours / 24) });
}

// "tra 2 h", "in ritardo di 3 h", "In pausa"
export function slaText(sla, t) {
  if (!sla) return '';
  if (sla.state === 'paused') return t('tickets.slaPaused');
  const diff = parseDbDate(sla.at) - new Date();
  const time = fmtDuration(diff, t);
  return diff < 0 ? t('tickets.slaAgo', { time }) : t('tickets.slaIn', { time });
}

// Classe del chip (stesse tinte della scadenza): late = rosso, soon = ambra.
export const SLA_CHIP_CLASS = { late: 'overdue', soon: 'warning', ok: 'ok', paused: 'paused' };
